// Creating timer
$(document).ready(function() {

 

  
    var totalTime = 15 * 60;
    var timer = setInterval(function() {
        totalTime--;
        var minutes = Math.floor(totalTime / 60);
        var seconds = totalTime % 60;
        $('.min_bar').text(minutes < 10 ? '0' + minutes : minutes);
        $('.sec_bar').text(seconds < 10 ? '0' + seconds : seconds);

        if (totalTime <= 0) {
            clearInterval(timer);
        }
    }, 1000);

  $('.lp_atc_btn_outer').click(function(evt){
    evt.preventDefault();
    $('html, body').animate({
        scrollTop: $(".product_section_holder").offset().top-100
    }, 500);
  });


 function startTimer(duration) {
    var timer = duration, hours, minutes, seconds;

    function updateTimerDisplay() {
        hours = Math.floor((timer / 3600) % 24);
        minutes = Math.floor((timer / 60) % 60);
        seconds = Math.floor(timer % 60);

        $('.offer_deal .val_bar').text(hours < 10 ? "0" + hours : hours);
        $('.offer_deal .min_bar').text(minutes < 10 ? "0" + minutes : minutes);
        $('.offer_deal .sec_bar').text(seconds < 10 ? "0" + seconds : seconds);
    }

    // Initial display update
    updateTimerDisplay();

    setInterval(function () {
        if (--timer < 0) {
            timer = duration;
        }
        updateTimerDisplay();
    }, 1000);
}

var twentyFourHours = 24 * 60 * 60; // 24 hours in seconds
startTimer(twentyFourHours);

});